export default {
  // 获取默认配置项目id和规则
  getProjectId:{
    url: "/attendanceConfig/getRuleProjectId",
    method: 'post',
    lodingState: true,
  },
  getEquipmentList:{
    url: "/userRecognition/selectUserRecognitionList",
    method: 'post',
    lodingState: true,
    doadmin: "zhgdApi"
  },
  // 供应商获取
   getSupplier:{
    url: "/supplier/selectSupplier",
    method: 'post',
    lodingState: true,
    doadmin: "zhgdApi"
  },
  // 获取考勤区域列表
   clockingInList:{
    url: "/projectArea/projectAreaList",
    method: 'post',
    lodingState: true,
    doadmin: "zhgdApi"
  },
  //新增考勤区域
  addSupplier:{
    url: "/projectArea/saveProjectArea",
    method: 'post',
    lodingState: true,
    doadmin: "zhgdApi"
  },
  // 删除考勤区域
  delSupplier:{
    url: "/projectArea/deleteProjectArea",
    method: 'post',
    lodingState: true,
    doadmin: "zhgdApi"
  },
  // 添加或者修改考勤机
  addOrSetAttendance:{
    url: "/userRecognition/saveOrUpdateUserRecognition",
    method: 'post',
    lodingState: true,
    doadmin: "zhgdApi"
  },
  // 删除设备
  delFacility:{
    url: "/userRecognition/deleteUserRecognition",
    method: 'post',
    lodingState: true,
    doadmin: "zhgdApi"
  },
  // 步骤一添加时间段
  addTimeQuantum:{
    url: "/attendanceRule/addAttendancePeriod",
    method: 'post',
    lodingState: true,
    doadmin: "zhgdApi"
  },
  // 步骤一的编辑查询
  inquireTimeQuantum:{
    url: "/attendanceRule/getAttendanceRule",
    method: 'post',
    lodingState: true,
    doadmin: "zhgdApi"
  },
  // 步骤二开启位置配置
  openPlace:{
    url: "/attendanceConfig/saveOrUpdateScope",
    method: 'post',
    lodingState: true,
  },
  // 步骤二的编辑查询
  inquirePlace:{
    url: "/attendanceConfig/searchScopeByCompanyId",
    method: 'post',
    lodingState: true,
  },
  // 考勤方式是否改变
  attendanceIsAlter:{
    url: "/attendanceRule/deleteAttendanceRuleAllArea",
    method: 'post',
    lodingState: true,
    doadmin: "zhgdApi"
  },
  // 第三步。添加人员
  addUserAttendanceRuleArea:{
    url: "/attendanceRule/addUserAttendanceRuleArea",
    method: 'post',
    lodingState: true,
    doadmin: "zhgdApi"
  },
  // 查询未添加考勤员工列表
  inquireStaffList:{
    url: "/attendanceRule/selectAttendanceUser",
    method: 'post',
    lodingState: true,
    doadmin: "zhgdApi"
  },
  // 添加人员考勤规则及区域
  addUser:{
    url: "/attendanceRule/addUserAttendanceRuleArea",
    method: 'post',
    lodingState: true,
    doadmin: "zhgdApi"
  },
  // 删除人员考勤规则及区域
  removeUser:{
    url: "/attendanceRule/deleteUserAttendanceRuleArea",
    method: 'post',
    lodingState: true,
    doadmin: "zhgdApi"
  },
  // 日考勤记录列表
  dayRecord:{
    url: "/companyAttendance/attendance/reportCompany",
    method: 'post',
    lodingState: true,
  },
  // 月考勤记录列表
  monthRecord:{
    url: "/companyAttendance/approve/monthAttendanceRecord",
    method: 'post',
    lodingState: true,
  },
  // 日考勤详情
  dayRecordDet:{
    url: "/companyAttendance/attendance/recordDetails",
    method: 'post',
    lodingState: true,
  },
  // 月考勤详情
  monthRecordDet:{
    url: "/companyAttendance/attendance/getUserAttendanceDetails",
    method: 'post',
    lodingState: true,
  },
  // 获取假勤审批
  getAttendanceApproval:{
    url: "/companyAttendance/approve/list",
    method: 'post',
    lodingState: true,
  },
  // 月考勤导出
  exportMonth:{
    url: "/companyAttendance/exportMonthAttendanceRecord",
    method: 'post',
    lodingState: true,
  },
  // 假期审批列表
  attendanceApprovalList:{
    url: "/companyAttendance/approve/myApproval",
    method: 'post',
    lodingState: true,
  },
  // 获取假勤类型
  leaveType:{
    url: "/companyAttendance/leaveType/list",
    method: 'post',
    lodingState: true,
  },
  vacationDet:{
    url: "/companyAttendance/approve/query",
    method: 'post',
    lodingState: true,
  },
  // 驳回审批
  rejectApprove:{
    url:'/companyAttendance/approval/operate',
    method: 'post',
    lodingState: true,
  },
  // 流程提示信息查询单个
  flowMessage:{
    url:'/companyAttendance/approveTips/query',
    method: 'post',
    lodingState: true,
  },
  // 工程拨付款统计
  engineeringFrom:{
    url:'/projectCount/projectFundsCount',
    method: 'post',
    lodingState: false,
  },
  // 施工日志和监理日志
  journalData:{
    url:'/projectCount/projectLogCount',
    method: 'post',
    lodingState: false,
  },
  // 业务流程未完成情况
  unfinished:{
    url:'/projectCount/flowUndone',
    method: 'post',
    lodingState: false,
  },
  // 获取滚动消息
  getMessage:{
    url:'/projectCount/showBigScreenMessage',
    method: 'post',
    lodingState: false,
  },
  // 获取项目阶段
  getPhase:{
    url:'/largeScreen/stageOfProject',
    method: 'post',
    lodingState: false,
  },
  //鼎信获取企业人员
  getDxStaff:{
    url:'/largeScreen/corporatePersonnel',
    method: 'post',
    lodingState: false,
  },
  // 鼎信获取施工日志和监理日志
  getDxLog:{
    url:'/largeScreen/projectLogCount',
    method: 'post',
    lodingState: false,
  },
  // 鼎信获取项目在建文件
  getDxFile:{
    url:'/largeScreen/projectFileCount',
    method: 'post',
    lodingState: false,
  },
  // 获取项目列表（贵阳）
  getGyProject:{
    url:'/supervisoryPlatform/projectList',
    method: 'post',
    lodingState: false,
  },
  // 获取监控视频列表
  getViodeList:{
    url:'/supervisoryPlatform/getCameraDataList',
    method: 'post',
    lodingState: false,
  },
  // 上传视频截图
  upLoadImg:{
    url:"/gsh/pic/saveScreenShot",
    method: 'post',
    lodingState: true,
  },
  // 获取抓拍截图列表
  getVideoScreenShot:{
    url:"/gsh/pic/list",
    method: 'post',
    lodingState: true,
  },
  // 初始化视频
  initializeVideo:{
    url:"/supervisoryPlatform/initDianXinYunVideo",
    method: 'post',
    lodingState: true,
  },

  // 获取告警设置列表
  getAlarmList:{
    url:"/gsh/alert/getOrderAlert",
    method: 'post',
    lodingState: true,
  },
  // 形象进度列表
  scheduleList:{
    url:"/gsh/visual/listVisualSchedule",
    method: 'post',
    lodingState: true,
  },
  // 新增形象进度
  addSchedule:{
    url:"/gsh/visual/saveVisualSchedule",
    method: 'post',
    lodingState: true,
  },
  // 形象进度查看详情
  visualScheduleDetails:{
    url:"/gsh/visual/scheduleDetail",
    method: 'post',
    lodingState: true,
  },
  // 查看进度详情
  examinePtls:{
    url:"/gsh/visual/progressReportDetail",
    method: 'post',
    lodingState: true,
  },
  // 查看督办记录详情
  getOverseeRecording:{
    url:"/gsh/visual/searchWorkOrderList",
    method: 'post',
    lodingState: true,
  },
  // 上报进度保存
  saveExamine:{
    url:"/gsh/visual/saveProgressReport",
    method: 'post',
    lodingState: true,
  },
  // 形象进度导入
  exportSchedule:{
    url:'/gsh/visual/importProgressReportExcel',
    method: 'post',
    lodingState: true,
  },
  // 验证阶段名称是否冲突
  verifyName:{
    url:'/gsh/visual/verifyTaskNodeName',
    method: 'post',
    lodingState: true,
  },
  // 确认导入
  affirmExport:{
    url:'/gsh/visual/confirmImport',
    method: 'post',
    lodingState: true,
  },
  // 工单超时修改
  editGd:{
    url:'/gsh/alert/updateAlertSetting',
    method: 'post',
    lodingState: true,
  },
  // 进度滞后修改
  editSchedule:{
    url:'/gsh/alert/updateLaggingBehindSetting',
    method: 'post',
    lodingState: true,
  },
  //要求时间完成管理
  accomplishTime:{
    url:'/gsh/alert/timeManagerFinish',
    method: 'post',
    lodingState: true,
  },
  // 要求时间未完成管理
  unfinishedTime:{
    url:'/gsh/alert/timeManagerNotFinish',
    method: 'post',
    lodingState: true,
  },
  // 工单时间管理获取记录
  getRecordTime:{
    url:'/gsh/alert/getLogs',
    method: 'post',
    lodingState: true,
  },
  // 获取项目看板信息
  getBoardInfo:{
    url: "/gsh/alert/",
    urlEnd: "/projectView",
    method: "post",
    lodingState: true
  },
  // 获取监控列表
  getVideoList:{
    url: "/camera/getCameraDataList",
    method: "post",
    doadmin: "zhgdApi"
  },
  // 查询项目负责人
  getPrincipal:{
    url: "/gsh/visual/searchProjectPrincipal",
    method: "post",
    lodingState: true
  },
  // 新的摄像头控制
  videoControl:{
    url: '/camera/ptzControl',
    method: "post",
    doadmin: "zhgdApi"
  },
  // 获取项目进度列表
  getProjectPlan:{
    url: "/gsh/workOrder/projectProgressManagementList",
    method: "post",
    lodingState: true
  },
  // 问题汇总列表
  problemSummary :{
    url: "/gsh/visual/searchProblemCollect",
    method: "post",
    lodingState: true
  },
  // 综合排名
  integratedRanking:{
    url: "/gsh/visual/searchPercentage",
    method: "post",
    lodingState: true
  },
  // 获取督办记录
  getOverseeRecord:{
    url: "/gsh/visual/searchWorkScheduleDetail",
    method: "post",
    lodingState: true
  },
  // 获取上报记录
  getReportedRecord:{
    url: "/gsh/visual/progressReportDetail",
    method: "post",
    lodingState: true
  },
  // 获取变更和删除记录列表
  getAlteration:{
    url: "/gsh/visual/scheduleChangeDetail",
    method: "post",
    lodingState: true
  },
  // 形象进度修改
  applyForOrDel:{
    url: "/gsh/visual/updateVisualSchedule",
    method: "post",
    lodingState: true
  },
  // 形象进度审批
  accraditationPlan:{
    url: "/gsh/visual/scheduleApprove",
    method: "post",
    lodingState: true
  },
  // 获取形象进度统计
  getCountSchedule:{
    url: "/gsh/visual/countSchedule",
    method: "post",
    lodingState: true
  },
  // 获取形象进度设置
  getSearchRemindSetting:{
    url: "/gsh/visual/searchRemindSetting",
    method: "post",
    lodingState: true
  },
  // 形象进度保存设置
  saveSetRemind:{
    url: "/gsh/visual/saveRemindSetting",
    method: "post",
    lodingState: true
  },
  // 获取留言
  getLeaveWord:{
    url: "/gsh/visual/listScheduleMessage",
    method: "post",
    lodingState: true
  },
  // 问题汇总-列表
  getProblemSummaryList:{
    url:"/gsh/problem/listProjectProblem",
    method: "post",
    lodingState: true
  },
  // 问题汇总-列表-详情
  problemSummaryDetails:{
    url:"/gsh/problem/searchProjectProblemDetail",
    method: "post",
    lodingState: true
  },
  // 按钮知晓该问题
  isKnowBtn:{
    url:"/gsh/problem/updateProjectProblem",
    method: "post",
    lodingState: true
  },
  // 项目进度删除
  delSchedule:{
    url:"/gsh/visual/deleteVisualSchedule",
    method: "post",
    lodingState: true
  }
}



// WEBPACK FOOTER //
// ./src/api/checkInset.js